export default Object.freeze({
  ITEM_ADDED_TO_WISHLIST: 0,
  API_FAILED_TO_ADD_ITEM_TO_WISHLIST: 1,
  API_SERVICE_UNAVAILABLE: 2,
  ITEM_ALREADY_EXIST_IN_WISHLIST: 3,
  ITEM_DELISTED_FROM_SITE: 4
});
